import React, { FC } from 'react';

import { AbstractMenuItem, Props } from '../abstract-menu-item';

const PosSystemsMenu: FC<Props> = props => {
  return (
    <AbstractMenuItem page="/pos-systems" name="POS Systems" {...props} />
  );
};

export { PosSystemsMenu };
